(function () {
  'use strict';

  /* =========================================================
     PREVENT DUPLICATE INITIALIZATION
     ========================================================= */

  if (window.G3CollectionFilterEnhancements) {
    return;
  }


  /* =========================================================
     SETTINGS
     ========================================================= */

  const MOBILE_BREAKPOINT = 768;

  const DELIVERY_DAYS_PARAM =
    'filter.p.m.custom.delivery_days';

  const READY_TO_SHIP_PARAM =
    'filter.p.m.custom.card_tags';

  const EXCLUDED_FILTER_IDS = [
    'filter-filter.v.option.size',
    'filter-filter.p.m.custom.discount',
    'filter-filter.p.m.custom.delivery_days'
  ];

  const VISIBLE_LIMIT = 6;


  /* =========================================================
     STATE
     ========================================================= */

  let initialized = false;

  let refreshTimeout = null;

  let observer = null;

  let observerRoot = null;

  let isRunningEnhancements = false;

  /*
 * Remember filters where the customer
 * has clicked Show More / Read More.
 *
 * We use filter IDs so the state can survive
 * Enterprise AJAX replacing the filter markup.
 */
const expandedFilterIds = new Set();


  /* =========================================================
     FILTER QUANTITY
     ========================================================= */

  function getFilterCount(item) {

    const countElement =
      item.querySelector('.filter__count');

    if (!countElement) {
      return 0;
    }

    const count =
      countElement.textContent.replace(
        /[^\d]/g,
        ''
      );

    return parseInt(count, 10) || 0;
  }


  /* =========================================================
     SORT ONE FILTER
     ========================================================= */

  function sortFilterList(list) {

    const filter =
      list.closest('.filter');

    if (!filter) {
      return;
    }


    /*
     * Do NOT sort:
     *
     * - Size
     * - Discount
     * - Delivery Days
     */
    if (
      EXCLUDED_FILTER_IDS.includes(
        filter.id
      )
    ) {
      return;
    }


    const currentItems =
      Array.from(
        list.children
      ).filter(function (item) {

        return item.tagName === 'LI';

      });


    if (currentItems.length < 2) {
      return;
    }


    /* =======================================
       SORT HIGHEST QUANTITY FIRST
       ======================================= */

    const sortedItems =
      currentItems
        .map(function (
          item,
          originalIndex
        ) {

          return {
            item: item,
            count: getFilterCount(item),
            originalIndex: originalIndex
          };

        })
        .sort(function (a, b) {

          if (b.count !== a.count) {
            return b.count - a.count;
          }

          /*
           * Preserve Shopify's original order
           * when quantities are equal.
           */
          return (
            a.originalIndex -
            b.originalIndex
          );

        })
        .map(function (entry) {

          return entry.item;

        });


    /*
     * Only change DOM order when required.
     */
    const orderChanged =
      sortedItems.some(
        function (item, index) {

          return (
            currentItems[index] !== item
          );

        }
      );


    if (orderChanged) {

      const fragment =
        document.createDocumentFragment();


      sortedItems.forEach(
        function (item) {

          fragment.appendChild(item);

        }
      );


      list.appendChild(fragment);

    }


    /* =======================================
       FIRST SIX + CHECKED OPTIONS
       ======================================= */

    /* =======================================
   FIRST SIX / EXPANDED STATE
   ======================================= */

const filterIsExpanded =
  Boolean(
    filter.id &&
    expandedFilterIds.has(filter.id)
  );


sortedItems.forEach(
  function (item, index) {

    const isChecked =
      Boolean(
        item.querySelector(
          'input[type="checkbox"]:checked'
        )
      );


    /*
     * If customer already clicked
     * Show More / Read More,
     * keep ALL options visible.
     */
    if (filterIsExpanded) {

      item.classList.remove(
        'js-hidden'
      );

      return;
    }


    /*
     * Otherwise:
     *
     * - first 6 visible
     * - checked values always visible
     */
    item.classList.toggle(
      'js-hidden',
      index >= VISIBLE_LIMIT &&
      !isChecked
    );

  }
);
  }


  /* =========================================================
     SORT ALL FILTERS
     ========================================================= */

  function sortAllFilters() {

    document
      .querySelectorAll(
        '.filter__content ul'
      )
      .forEach(
        sortFilterList
      );
  }


  /* =========================================================
     DELIVERY DAYS
     ========================================================= */

  function getRemovedFilterValue(
    link,
    parameterName
  ) {

    const currentUrl =
      new URL(
        window.location.href
      );


    const destinationUrl =
      new URL(
        link.href,
        window.location.origin
      );


    const currentValues =
      currentUrl.searchParams.getAll(
        parameterName
      );


    const remainingValues =
      destinationUrl.searchParams.getAll(
        parameterName
      );


    if (!currentValues.length) {
      return null;
    }


    const remainingValueCounts =
      new Map();


    remainingValues.forEach(
      function (value) {

        remainingValueCounts.set(
          value,
          (
            remainingValueCounts.get(
              value
            ) || 0
          ) + 1
        );

      }
    );


    for (const value of currentValues) {

      const remainingCount =
        remainingValueCounts.get(
          value
        ) || 0;


      if (remainingCount === 0) {
        return value;
      }


      remainingValueCounts.set(
        value,
        remainingCount - 1
      );
    }


    return null;
  }


  function updateActiveFilterText(
    link,
    newText
  ) {

    const textNode =
      Array.from(
        link.childNodes
      ).find(
        function (node) {

          return (
            node.nodeType ===
              Node.TEXT_NODE &&
            node.textContent.trim() !== ''
          );

        }
      );


    if (textNode) {

      textNode.textContent =
        '\n ' + newText;

    } else {

      link.appendChild(
        document.createTextNode(
          ' ' + newText
        )
      );

    }
  }


  function addDeliveryDays() {

    /* =======================================
       DELIVERY DAYS FILTER VALUES
       ======================================= */

    document
      .querySelectorAll(
        '#filter-filter\\.p\\.m\\.custom\\.delivery_days .filter__label .flex-auto'
      )
      .forEach(
        function (element) {

          const value =
            element.textContent.trim();


          /*
           * Only modify pure numeric values.
           *
           * Prevents:
           *
           * "2 Days" → "2 Days Days"
           */
          if (/^\d+$/.test(value)) {

            element.textContent =
              value + ' Days';

          }

        }
      );


    /* =======================================
       ACTIVE FILTER CHIPS
       ======================================= */

    document
      .querySelectorAll(
        '.active-filters a.active-filter'
      )
      .forEach(
        function (link) {

          const removedValue =
            getRemovedFilterValue(
              link,
              DELIVERY_DAYS_PARAM
            );


          /*
           * Not a Delivery Days chip.
           */
          if (removedValue === null) {
            return;
          }


          const numericValue =
            removedValue.trim();


          if (
            !/^\d+$/.test(
              numericValue
            )
          ) {
            return;
          }


          updateActiveFilterText(
            link,
            numericValue + ' Days'
          );

        }
      );
  }


  /* =========================================================
     READY TO SHIP ONLY
     ========================================================= */

  function keepOnlyReadyToShip() {

    const filter =
      document.querySelector(
        '#filter-filter\\.p\\.m\\.custom\\.card_tags'
      );


    if (!filter) {
      return;
    }


    filter
      .querySelectorAll(
        'input[name="' +
        READY_TO_SHIP_PARAM +
        '"]'
      )
      .forEach(
        function (input) {

          if (
            input.value.trim() ===
            'Ready to Ship'
          ) {
            return;
          }


          const item =
            input.closest('li');


          if (item) {
            item.remove();
          }

        }
      );
  }


  /* =========================================================
     RUN ALL FILTER ENHANCEMENTS
     ========================================================= */

  function runEnhancements() {

    if (isRunningEnhancements) {
      return;
    }


    isRunningEnhancements = true;


    /*
     * Temporarily stop our observer while
     * WE modify the filter DOM.
     *
     * Prevents observer loops.
     */
    if (observer) {
      observer.disconnect();
    }


    sortAllFilters();

    addDeliveryDays();

    keepOnlyReadyToShip();


    /*
     * Remove mutations caused by our own work.
     */
    if (observer) {

      observer.takeRecords();

      reconnectObserver();

    }


    isRunningEnhancements = false;


    /*
     * Let other G3 scripts know that
     * Shopify's filter DOM is ready again.
     */
    document.dispatchEvent(
      new CustomEvent(
        'g3:filters-updated'
      )
    );
  }


  /* =========================================================
     DEBOUNCED REFRESH
     ========================================================= */

  function scheduleRefresh(delay) {

    if (!initialized) {
      return;
    }


    clearTimeout(
      refreshTimeout
    );


    refreshTimeout =
      setTimeout(
        function () {

          runEnhancements();

        },
        typeof delay === 'number'
          ? delay
          : 80
      );
  }


  /* =========================================================
     CHECK AJAX MUTATION
     ========================================================= */

  function mutationContainsFilters(
    mutation
  ) {

    const relevantSelector =
      [
        '#facet-filters',
        '.filter__content',
        '.active-filters',
        '.products-toolbar__filter',
        'details[id^="filter-"]'
      ].join(',');


    const target =
      mutation.target.nodeType ===
        Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;


    /*
     * Change happened directly inside
     * existing filter markup.
     */
    if (
      target &&
      target.closest &&
      target.closest(
        relevantSelector
      )
    ) {
      return true;
    }


    /*
     * Shopify may replace an entire section.
     *
     * Check newly-added nodes for filters.
     */
    return Array.from(
      mutation.addedNodes
    ).some(
      function (node) {

        if (
          node.nodeType !==
          Node.ELEMENT_NODE
        ) {
          return false;
        }


        if (
          node.matches &&
          node.matches(
            relevantSelector
          )
        ) {
          return true;
        }


        return Boolean(
          node.querySelector &&
          node.querySelector(
            relevantSelector
          )
        );

      }
    );
  }


  /* =========================================================
     OBSERVER
     ========================================================= */

  function reconnectObserver() {

    if (!observer) {
      return;
    }


    /*
     * Observe MAIN instead of BODY.
     *
     * Important:
     * We watch CHILD changes only.
     *
     * We do NOT watch:
     * - style
     * - class
     * - aria attributes
     */
    observerRoot =
      document.querySelector('main') ||
      document.body;


    observer.observe(
      observerRoot,
      {
        childList: true,
        subtree: true
      }
    );
  }


  function startObserver() {

    if (observer) {
      return;
    }


    observer =
      new MutationObserver(
        function (mutations) {

          if (isRunningEnhancements) {
            return;
          }


          const relevantMutation =
            mutations.some(
              mutationContainsFilters
            );


          if (relevantMutation) {

            scheduleRefresh(80);

          }

        }
      );


    reconnectObserver();
  }


  /* =========================================================
     INITIALIZE
     ========================================================= */

  function initialise() {

    if (initialized) {
      return;
    }


    initialized = true;


    /*
     * First filter preparation.
     */
    runEnhancements();


    /*
     * Observer starts ONLY AFTER
     * customer interaction.
     */
    startObserver();


    /* =======================================
       CHECKBOX / RADIO
       ======================================= */

    document.addEventListener(
      'change',
      function (event) {

        const target =
          event.target;


        if (
          !target ||
          !target.matches
        ) {
          return;
        }


        if (
          target.matches(
            '.filter__content input[type="checkbox"], .filter__content input[type="radio"]'
          )
        ) {

          scheduleRefresh(100);

        }

      }
    );


    /* =======================================
       BROWSER BACK/FORWARD
       ======================================= */

    window.addEventListener(
      'popstate',
      function () {

        scheduleRefresh(100);

      }
    );


    /* =======================================
       SHOPIFY THEME EDITOR
       ======================================= */

    document.addEventListener(
      'shopify:section:load',
      function () {

        scheduleRefresh(60);

      }
    );
  }

/* =========================================================
   SHOW MORE / READ MORE
   ========================================================= */

function isShowMoreControl(element) {

  if (
    !element ||
    !element.closest
  ) {
    return false;
  }


  const control =
    element.closest(
      'button, a'
    );


  if (!control) {
    return false;
  }


  const text =
    control.textContent
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');


  /*
   * Support different wording that
   * Enterprise/custom theme may use.
   */
  return (
    text.includes('show more') ||
    text.includes('read more') ||
    text.includes('view more')
  );
}


document.addEventListener(
  'click',
  function (event) {

    if (
      !isShowMoreControl(
        event.target
      )
    ) {
      return;
    }


    const control =
      event.target.closest(
        'button, a'
      );


    const filter =
      control &&
      control.closest(
        '.filter'
      );


    if (!filter) {
      return;
    }


    /*
     * Remember that this particular
     * filter has been expanded.
     */
    if (filter.id) {

      expandedFilterIds.add(
        filter.id
      );

    }


    const list =
      filter.querySelector(
        '.filter__content ul'
      );


    if (!list) {
      return;
    }


    /*
     * Let Enterprise complete its normal
     * Show More behaviour first.
     */
    setTimeout(
      function () {

        list
          .querySelectorAll(
            ':scope > li.js-hidden'
          )
          .forEach(
            function (item) {

              item.classList.remove(
                'js-hidden'
              );

            }
          );

      },
      0
    );

  },
  true
);

  /* =========================================================
     ACTIVATION DETECTION
     ========================================================= */

  function isFilterInteraction(
    target
  ) {

    if (
      !target ||
      !target.closest
    ) {
      return false;
    }


    return Boolean(
      target.closest(
        [
          '#facet-filters',
          '.filter',
          '.active-filters',
          '.products-toolbar__filter'
        ].join(',')
      )
    );
  }


  /*
   * IMPORTANT:
   *
   * Capturing phase means this runs before
   * Enterprise handles the user's click.
   *
   * Therefore filters are prepared before
   * the drawer becomes visible.
   */
  document.addEventListener(
    'pointerdown',
    function (event) {

      if (
        isFilterInteraction(
          event.target
        )
      ) {

        initialise();

      }

    },
    true
  );


  /*
   * Keyboard / programmatic click fallback.
   */
  document.addEventListener(
    'click',
    function (event) {

      if (
        isFilterInteraction(
          event.target
        )
      ) {

        initialise();

      }

    },
    true
  );


  /*
   * Keyboard navigation.
   */
  document.addEventListener(
    'focusin',
    function (event) {

      if (
        isFilterInteraction(
          event.target
        )
      ) {

        initialise();

      }

    },
    true
  );


  /* =========================================================
     DESKTOP
     ========================================================= */

  /*
   * Desktop users can see filters directly,
   * so prepare them on their FIRST SCROLL.
   *
   * Nothing is done during initial render.
   */
  if (
    window.innerWidth >=
    MOBILE_BREAKPOINT
  ) {

    window.addEventListener(
      'scroll',
      initialise,
      {
        once: true,
        passive: true
      }
    );

  }


  /* =========================================================
     PUBLIC OBJECT
     ========================================================= */

  window.G3CollectionFilterEnhancements = {

    init: initialise,

    refresh: function () {

      if (initialized) {

        scheduleRefresh(0);

      }

    },

    get initialized() {

      return initialized;

    }

  };

})();